import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';

const mainListItems = [
  { text: 'Overview',   icon: <HomeRoundedIcon />,      path: '/' },
  { text: 'Hazards',    icon: <WarningRoundedIcon />,   path: '/hazards' },
  { text: 'Scenarios',  icon: <AnalyticsRoundedIcon />, path: '/scenarios' },
  { text: 'Statistics', icon: <HubRoundedIcon />,       path: '/statistics' },
  { text: 'Settings',   icon: <SettingsRoundedIcon />,  path: '/settings' },
  { text: 'About',      icon: <InfoRoundedIcon />,      path: '/about' },
  { text: 'Feedback',   icon: <HelpRoundedIcon />,      path: '/feedback' },
];

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => navigate(item.path)}
              selected={location.pathname === item.path}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}